import { render, staticRenderFns } from "./v-content.vue?vue&type=template&id=411ff30a&scoped=true&"
import script from "./v-content.vue?vue&type=script&lang=js&"
export * from "./v-content.vue?vue&type=script&lang=js&"
import style0 from "./v-content.vue?vue&type=style&index=0&id=411ff30a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411ff30a",
  null
  
)

export default component.exports